module.exports = __webpack_public_path__ + "img/album07_02.c5e859db.jpg";